import { MotivoSustitucion, TipoConversion, TipoExpulsion } from '../constantes/Parametros.js';
import * as TipoSustitucion from '../constantes/TipoSustitucion.js';

export const ItemFormacionVacio = (idPartido, equipo, orden, titularidad) => {
  return {
    idPartidoFormacion: 0,
    idPartido: idPartido,
    equipo: equipo,
    persona: null,
    personaSinId: null,
    orden: orden,
    camiseta: null,
    titularidad: titularidad,
    goles: null,
    idSustitucionSale: null,
    tiempoSale: null,
    minutosSale: null,
    motivoCambio: null,
    idSustitucionEntra: null,
    tiempoEntra: null,
    minutosEntra: null,
    amonestado: false,
    expulsado: false,
    idExpulsion: null,
    tiempoExpulsado: null,
    minutosExpulsado: null,
    tipoExpulsion: null,
    modificado: false, // Indica si el registro fue modificado desde su carga
  };
};

export const MapFormacionDesdeBackend = (formacionBackend) => {
  if (!formacionBackend || !Array.isArray(formacionBackend)) {
    return [];
  }

  return formacionBackend.map((item) => {
    // El backend devuelve personaSinId como objeto: { apellido: "...", nombre: "..." }
    // Pero en PUT/POST se envía como campos separados: apellidoPersonaSinId y nombrePersonaSinId
    // Esta función normaliza el formato del GET para usar internamente
    let personaSinId = null;
    if (
      item.personaSinId &&
      item.personaSinId.apellido &&
      item.personaSinId.apellido.trim().length > 0
    ) {
      personaSinId = {
        apellido: item.personaSinId.apellido.trim(),
        nombre: item.personaSinId.nombre ? item.personaSinId.nombre.trim() : '',
      };
    }

    return {
      ...item,
      personaSinId: personaSinId,
      modificado: false, // Los registros del backend no están modificados inicialmente
    };
  });
};

export const ExpulsionVacia = (participante) => {
  return {
    id: 0,
    equipo: participante && participante.equipo,
    idFormacion: participante && participante.idPartidoFormacion,
    persona: participante && participante.persona,
    personaSinId: participante && participante.personaSinId,
    expulsado: false,
    tiempo: null,
    minutos: null,
    tipoExpulsion: TipoExpulsion.EXPULSADO,
  };
};

export const ExpulsionParticipante = (participante) => {
  return {
    id: participante.idExpulsion,
    equipo: participante.equipo,
    idFormacion: participante.idPartidoFormacion,
    persona: participante.persona,
    personaSinId: participante.personaSinId,
    expulsado: true,
    tiempo: participante.tiempoExpulsado,
    minutos: participante.minutosExpulsado,
    tipoExpulsion:
      participante.tipoExpulsion === null ? TipoExpulsion.EXPULSADO : participante.tipoExpulsion,
  };
};

export const GolVacio = (equipo, participante) => {
  // Crear formacionJugador con la estructura que espera NombreApellidoGol
  let formacionJugador = null;
  if (participante) {
    formacionJugador = {
      idPartidoFormacion: participante.idPartidoFormacion,
      persona: participante.persona,
      apellidoPersonaSinId: participante.personaSinId && participante.personaSinId.apellido,
      nombrePersonaSinId: participante.personaSinId && participante.personaSinId.nombre,
    };
  }

  return {
    id: 0,
    equipo: equipo,
    idFormacionJugador: participante && participante.idPartidoFormacion,
    jugador: participante && participante.persona,
    formacionJugador: formacionJugador,
    tiempo: null,
    minutos: null,
    tipoConversion: TipoConversion.SIN_CLASIFICAR,
  };
};

export const SustitucionVacia = () => {
  return {
    id: 0,
    equipo: null,
    tiempo: null,
    minutos: null,
    idFormacionEntra: null,
    participanteEntra: null,
    jugadorEntra: null,
    idFormacionSale: null,
    participanteSale: null,
    jugadorSale: null,
    sinIngreso: false,
    motivo: MotivoSustitucion.REEMPLAZO,
    detalle: '',
  };
};

export const SustitucionParticipante = (participante, tipoSustitucion) => {
  return {
    id: participante.idSustitucion,
    equipo: participante.equipo,
    tiempo:
      tipoSustitucion === TipoSustitucion.ENTRA
        ? participante.tiempoEntra
        : participante.tiempoSale,
    minutos:
      tipoSustitucion === TipoSustitucion.ENTRA
        ? participante.minutosEntra
        : participante.minutosSale,
    idFormacionEntra:
      tipoSustitucion === TipoSustitucion.ENTRA ? participante.idPartidoFormacion : null,
    participanteEntra: tipoSustitucion === TipoSustitucion.ENTRA ? participante : null,
    jugadorEntra: tipoSustitucion === TipoSustitucion.ENTRA ? participante.persona : null,
    idFormacionSale:
      tipoSustitucion === TipoSustitucion.SALE ? participante.idPartidoFormacion : null,
    participanteSale: tipoSustitucion === TipoSustitucion.SALE ? participante : null,
    jugadorSale: tipoSustitucion === TipoSustitucion.SALE ? participante.persona : null,
    sinIngreso: false,
    motivo: MotivoSustitucion.REEMPLAZO,
    detalle: '',
  };
};
